// 订单项类型枚举，保持与后端一致
export const orderItemTypeEnums = Object.freeze([
  { value: 1, label: '早餐费用' },
  { value: 2, label: '加床费用' },
  { value: 3, label: '第三人费用' },
  { value: 4, label: '接送机费用' },
  { value: 5, label: '改价补差' },
  { value: 6, label: '杂项', deprecated: true }, // 废弃类型，保留历史订单项展示
  { value: 7, label: '押金' },
  { value: 8, label: '交通费' },
  { value: 9, label: '延住' },
  { value: 10, label: '改期' },
  { value: 11, label: '额外礼遇' },
  { value: 12, label: '额外升级' },
  { value: 13, label: '税费' },
  { value: 14, label: '转账手续费' }
])

export const orderItemTypeMap = Object.freeze(orderItemTypeEnums.reduce((result, current) => {
  result[current.value] = current.label
  return result
}, {}))

export const orderItemTypeList = Object.freeze(orderItemTypeEnums.filter(item => !item.deprecated).map(item => item.value))
